import React, { useCallback } from "react";
import { HiOutlineMail } from "react-icons/hi";
import { MdClose } from "react-icons/md";

import ContainedButton from "components/layout/form/containedButton";

import {
  Container,
  ContainerButtons,
  ContainerText,
  IconContainer,
  ModalHeader,
  ModalStyle,
  Text,
  Title,
} from "./styles";

type EmailConfirmProps = any;

const EmailConfirm = ({
  openModal,
  modalFunction,
  email,
  onlyAddress,
  redirectFunction,
}: EmailConfirmProps): JSX.Element => {
  const handleCloseModal = useCallback(() => {
    modalFunction();
    redirectFunction();
  }, [modalFunction, redirectFunction]);

  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <Title>
          {" "}
          {onlyAddress ? "Atualizado com sucesso!" : "Aguardando confirmação"}
        </Title>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        {!onlyAddress && (
          <ContainerText>
            <IconContainer>
              <HiOutlineMail size={20} color="#F0B01B" />
            </IconContainer>

            <Text>
              Confirme seu email com o link enviado para {email}. Sua alteração
              será salva após a confirmação!
            </Text>
          </ContainerText>
        )}
        <span>
          As alterações solicitadas serão efetuadas em até 01 (um) mês.
        </span>
        <ContainerButtons>
          <ContainedButton onClick={() => handleCloseModal()}>
            OK
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default EmailConfirm;
